module.exports = __webpack_public_path__ + "static/img/3.8484dfc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/sp/3.png
// module id = +Slw
// module chunks = 0